define(function (require, exports) {
    'use strict';

    exports.list = function () {
        return {
            restrict: 'E',
            template:
            '<div ng-repeat="model in model.items">' +
            '   <element/>' +
            '</div>'
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/list.js